export default "__VITE_ASSET__DPR76qO4__"